// vue3-migration -- Element
import langPt from 'element-plus/es/locale/lang/pt';
import translations from './translations.json';
import 'moment/locale/pt';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langPt,
};
